import {
  TableCell,
  TableRow,
  TableContainer,
  tableCellClasses,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const StyledTableContainer = styled(TableContainer)(() => ({
  width: '100%',
  paddingBottom: '10px',
}));

export const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: '600',
    fontSize: '16px',
    color: '#F2F2F2',
    backgroundColor: theme.palette.secondary.main,
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    borderRight: '1px solid #F2F2F2',
    '&:last-child': {
      borderRight: '0',
    },
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: '#fff',
  fontWeight: '600',
  fontSize: '16px',
  padding: '0 12px',
  height: 47,
  borderLeft: `1px solid ${theme.palette.secondary.main}`,
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
  '&:last-child': {
    borderRight: `1px solid ${theme.palette.secondary.dark}`,
  },
  '& span': {
    fontSize: 21,
  },
}));

export const Row = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.grey, 0.2),
  },
}));
